import { useEffect } from "react";
import { createMicroConversionTrackingUtils } from "..";
import useProfiler from "../../../hooks/useProfiler";
import { RouteName } from "@flights/constants";

const utils = createMicroConversionTrackingUtils({
  name: "flights_web_align_seatmap_structure",
  stages: {
    routeDecision: 1, // dummy stage
    main: 2, // seatmap page
    direct: 3,
    meta: 4,
    oneWay: 5,
    roundTrip: 6,
    solo: 7,
    nonsolo: 8,
    us: 9
  },
  defaultStage: 1,
  mainStage: 2,
  goals: {
    skipSeatSelection: 1,
    selectedSeatForAnyTraveller: 2,
    priceOrUnifiedBreakdownExpanded: 3,
    clickAccordionToSelectSeats: 4
  },
  goalsWithValue: []
});

const useTrackAlignSeatmapStructure = () => {
  const { stages } = utils;
  const { isDirect, isOneWay, isSolo, isAmerican } = useProfiler();
  useEffect(() => {
    stages.main();
    isSolo() ? stages.solo() : stages.nonsolo();
    isDirect() ? stages.direct() : stages.meta();
    isOneWay() ? stages.oneWay() : stages.roundTrip();
    isAmerican() && stages.us();
  }, [isSolo, isDirect, isOneWay, isAmerican, stages]);
};

const useTrackPriceBreakdownClick = (currentRoute: RouteName) => {
  if (currentRoute === "checkout-seat-selection") {
    utils.goals.priceOrUnifiedBreakdownExpanded();
  }
};

let didSelectSeat = false;
const useTrackSelectedSeat = (currentRoute: RouteName) => {
  if (currentRoute === "checkout-seat-selection" && !didSelectSeat) {
    utils.goals.selectedSeatForAnyTraveller();
    didSelectSeat = true;
  }
};

let didClickAccordion = false;
const useTrackClickAccordion = (currentRoute: RouteName) => {
  if (currentRoute === "checkout-seat-selection" && !didClickAccordion) {
    utils.goals.clickAccordionToSelectSeats();
    didClickAccordion = true;
  }
};

export default {
  ...utils,
  useTrackAlignSeatmapStructure,
  useTrackPriceBreakdownClick,
  useTrackSelectedSeat,
  useTrackClickAccordion
};
